
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChildren, QueryList} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { InputFieldComponent } from '../../../../components/form/input-field/input-field.component';
import { SelectFieldComponent } from '../../../../components/form/select-field/select-field.component';
import { TextAreaFieldComponent } from '../../../../components/form/textarea-field/textarea-field.component';
import { SwitchFieldComponent } from '../../../../components/form/switch-field/switch-field.component';
import { LanguageClientComponent } from '../../../../components/form/language-client/language-client.component';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { AlertInfo } from '../../../../models/alert-info';
import { FormService } from '../../../../services/form.service';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { AutocompleteFieldComponent } from '../../../../components/form/autocomplete-field/autocomplete-field.component';
import { CustomerService } from '../../../../services/api/customer.service';
import { HttpParams } from '@angular/common/http';
import { CountriesService } from 'src/app/services/api/general-settings/countries.service';
import { OptionService } from 'src/app/services/api/option.service';
import { RouteService } from '../../../../services/route.service';

@Component({
  selector: 'customers-form',
  imports: [ReactiveFormsModule, InputFieldComponent, SwitchFieldComponent, LanguageClientComponent, NgbAlert, SelectFieldComponent, AutocompleteFieldComponent],
  templateUrl: './customers-form.component.html',
  styleUrls: ['./customers-form.component.scss']
})
export class FormCustomersComponent implements OnInit, OnChanges {
  form!: FormGroup;
  alertInfo: AlertInfo = { show: false, type: '', message: '' };
  optionsRegistrationType: { key: string, value: string }[] = [{ key: 'VAT', value: 'VAT' }, { key: 'TAX', value: 'TAX' }]
  selectedRegistrationType: string | undefined = '';
  originalRegistrationValues: Record<string, string> = {
    'VAT': '',
    'TAX': ''
  };
  optionsCustomerType: { key: string, value: string }[] = []
  countriesOptions: { key: number; value: string }[] = [];
  optionsIntroducer: { key: string | number, value: string }[] = [];

  @Input() readonlyCustomerForm!: boolean
  @Input() customer!: any;
  @Input() additionalData: { ranking: number; code: string } = { ranking: 0, code: '' };
  @Input() skipNavigationOnCreate: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();
  @Output() codeRequired = new EventEmitter<boolean>();
  @Output() saveRequested = new EventEmitter<void>();

  optionsCompanyCountry = ["--select", "Spain", "Italy"];

  @ViewChildren(AutocompleteFieldComponent) autocompleteFields!: QueryList<AutocompleteFieldComponent>;

  constructor(private alertNotificationService: AlertNotificationService, private formService: FormService, protected customerService: CustomerService, protected countriesService: CountriesService, protected optionsService: OptionService, private routeService: RouteService) {
    this.form = new FormGroup({
      brand: new FormControl('', ),
      companyName: new FormControl('', [Validators.required]),
      customerTypeId: new FormControl('', [Validators.required]),
      countryId: new FormControl('', [Validators.required]),
      address: new FormControl('', [Validators.required]),
      zipCode: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      registrationTypeValue: new FormControl('',),
      registrationType: new FormControl('',),
      languageId: new FormControl(146, [Validators.required]),
      isClient: new FormControl(false),
      directorName: new FormControl('', [Validators.required]),
      directorDocument: new FormControl('', [Validators.required]),
      introducerId: new FormControl(null,),
    });
    const params = new HttpParams().set('size', '9999');

    this.optionsRegistrationType = [{ key: 'VAT', value: 'VAT' }, { key: 'TAX', value: 'TAX' }],
    this.customerService.listSettingsClientsTypes().subscribe((clientTypes: any) => {
      this.optionsCustomerType = clientTypes?.data?.customerTypes?.map((clientType: any) => ({ key: clientType.customerTypeId, value: clientType.name }));
    })
    this.countriesService.list({ params }).subscribe((countries: any) => {
      this.countriesOptions = countries?.data?.countries?.map((country: any) => ({ key: country.countryId, value: country.name }));
    });
   this.optionsService.introducers().subscribe((introducers: any) => {
      this.optionsIntroducer = introducers?.data?.introducers?.map((introducer: any) => ({ key: introducer.introducerId, value: introducer.name }));
    });
  }
  ngOnInit(): void {
    setTimeout(() => {
      if (this.customer) {
        const registrationType = this.getRegistrationType();
        const registrationTypeValue = this.getRegistrationTypeValue();
        
        if (registrationType && registrationTypeValue) {
          this.originalRegistrationValues[registrationType] = registrationTypeValue;
        }
        
        this.form.patchValue({
          brand: this.customer.brand,
          companyName: this.customer.companyName || '',
          customerTypeId: this.customer.customerType?.customerTypeId || '',
          countryId: Number(this.customer.country.countryId) || '',
          address: this.customer.address || '',
          zipCode: this.customer.zipCode || '',
          city: this.customer.city || '',
          registrationTypeValue: registrationTypeValue || '',
          registrationType: registrationType || '',
          languageId: this.customer.language.languageId || '',
          isClient: this.customer.isClient || false,
          directorName: this.customer.directorName || '',
          directorDocument: this.customer.directorDocument || '',
          introducerId: Number(this.customer.introducer?.introducerId) || '',
        });
        this.selectedRegistrationType = registrationType;
        this.updateRegistrationTypeValidation(this.selectedRegistrationType);
        
        this.getRegistrationTypeValueInput().valueChanges.subscribe(value => {
          if (this.selectedRegistrationType) {
            this.originalRegistrationValues[this.selectedRegistrationType] = value;
          }
        });
      }
    }, 500);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customer'] && changes['customer'].currentValue) {
      const registrationType = this.getRegistrationType();
      const registrationTypeValue = this.getRegistrationTypeValue();
      
      if (registrationType && registrationTypeValue) {
        this.originalRegistrationValues[registrationType] = registrationTypeValue;
      }
      
      this.form.patchValue({
        brand: this.customer.brand,
        companyName: this.customer.companyName,
        customerTypeId: this.customer.customerType?.customerTypeId,
        countryId: Number(this.customer.country.countryId),
        address: this.customer.address,
        zipCode: this.customer.zipCode,
        city: this.customer.city,
        registrationTypeValue: registrationTypeValue,
        registrationType: registrationType,
        languageId: this.customer.clientLanguage,
        isClient: this.customer.isClient,
        directorName: this.customer.directorName,
        directorDocument: this.customer.directorDocument,
        introducerId: this.customer.introducer?.introducerId,
      });
      this.selectedRegistrationType = registrationType;
      this.updateRegistrationTypeValidation(this.selectedRegistrationType);
    }
  }

  updateRegistrationTypeValidation(registrationType: string | undefined): void {
    const registrationTypeValueControl = this.form.get('registrationTypeValue');
    
    if (registrationTypeValueControl) {
      registrationTypeValueControl.clearValidators();
      
      if (registrationType === 'VAT' || registrationType === 'TAX') {
        registrationTypeValueControl.setValidators([Validators.required]);
      }
      
      registrationTypeValueControl.updateValueAndValidity();
    }
  }

  onRegistrationTypeChange(newValue: any): void {
    this.selectedRegistrationType = newValue;
    this.getRegistrationTypeInput().setValue(newValue);
    
    if (this.originalRegistrationValues[newValue]) {
      this.getRegistrationTypeValueInput().setValue(this.originalRegistrationValues[newValue]);
    } else {
      this.getRegistrationTypeValueInput().setValue('');
    }
    
    this.updateRegistrationTypeValidation(newValue);
  }

  onSwitchChange(event: boolean | { isChecked: boolean; item: any }): void {
    if (typeof event === 'boolean') {
      this.form.get('isClient')?.setValue(event);
    } else {
      const { isChecked } = event;
      this.form.get('isClient')?.setValue(isChecked);
    }
  }

    private disableAutocompleteDropdowns(): void {
      if (this.autocompleteFields) {
        this.autocompleteFields.forEach(field => {
          field.setPreventAutoOpen(true);
        });
      }
    }
    private enableAutocompleteDropdowns(delay: number = 2000): void {
      setTimeout(() => {
        if (this.autocompleteFields) {
          this.autocompleteFields.forEach(field => {
            field.setPreventAutoOpen(false);
          });
        }
      }, delay);
    }

  /**
     * *******************
     * Submit form methods
     * *******************
     */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any, isCreate: boolean) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });

    if (isCreate && !this.skipNavigationOnCreate) {
      const customerId = this.getCreatedCustomerId(response);
      if (customerId) {
        setTimeout(() => {
          this.routeService.customerUpdate(customerId);
        }, 1000);
      }
    }
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {
    this.disableAutocompleteDropdowns();
    
    const { registrationType, registrationTypeValue, introducerId, customerTypeId, countryId, ...filteredFormData } = {
      ...this.form.value,
      ...this.additionalData
    };
    const selectedCountry = this.countriesOptions.find(option => option.value === countryId);
    const updatedCountryId = selectedCountry ? selectedCountry.key : countryId;

    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    const isCodeValid = !!(this.additionalData.code && this.additionalData.code.trim());
    this.codeRequired.emit(!isCodeValid);

    if (!isCodeValid) {
      this.showAlertInfo('danger', 'Client Code is required');
      this.enableAutocompleteDropdowns(2000);
      return;
    }

    if (this.form.valid) {
      const introducerKey = this.optionsIntroducer.find(option => option.value === introducerId)?.key || null;

      const values = Object.assign(
        filteredFormData,
        {
          introducerId: introducerKey,
          customerTypeId: customerTypeId ? Number(customerTypeId) : null,
          countryId: updatedCountryId ? Number(updatedCountryId) : null,
          registrationType: registrationType,
          registrationTypeValue: registrationTypeValue,
          tenantId: 1,
        },
      );
      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      const isCreate = !this.customer;
      const serviceMethod = this.customer ? this.customerService.update(this.customer.customerId, values) : this.customerService.create(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response, isCreate);
          this.enableAutocompleteDropdowns(2000);
        },
        error: (error) => {
          this.submitFormError(error);
          this.enableAutocompleteDropdowns(2000);
        }
      });
    } else {
      this.enableAutocompleteDropdowns(2000);
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */

  isFormValid(): boolean {
    const isCodeValid = !!(this.additionalData.code && this.additionalData.code.trim());
    return this.form.valid && isCodeValid;
  }


  getAddressInput(): FormControl { return this.getInputControl('address'); }
  getBrandInput(): FormControl { return this.getInputControl('brand'); }
  getZipCodeInput(): FormControl { return this.getInputControl('zipCode'); }
  getCityInput(): FormControl { return this.getInputControl('city'); }
  getRegistrationTypeValueInput(): FormControl { return this.getInputControl('registrationTypeValue'); }
  getRegistrationTypeInput(): FormControl { return this.getInputControl('registrationType'); }
  getClientLanguageInput(): FormControl { return this.getInputControl('languageId'); }
  getIsClientInput(): FormControl { return this.getInputControl('isClient'); }
  getDirectorNameInput(): FormControl { return this.getInputControl('directorName'); }
  getDirectorDocumentInput(): FormControl { return this.getInputControl('directorDocument'); }
  getAutocompleteCompanyNameInput(): FormControl { return this.getInputControl('companyName'); }
  getAutocompleteCountryInput(): FormControl { return this.getInputControl('countryId'); }
  getAutocompleteIntroducernput(): FormControl { return this.getInputControl('introducerId'); }
  getCustomerTypetInput(): FormControl { return this.getInputControl('customerTypeId'); }

  getInputControl(name: string): FormControl { return this.form.get(name) as FormControl; }
  getSelectControl(name: string): FormControl { return this.form.get(name) as FormControl; }

  onSearchValueChange(value: any): void {
  }

  getRegistrationType(): string | undefined {
    if (this.customer && this.customer.registrationType) {
      if (['VAT', 'TAX'].includes(this.customer.registrationType.toUpperCase())) {
        return this.customer.registrationType.toUpperCase();
      }
      
      if (this.customer.vat && !this.customer.tax) {
        return 'VAT';
      } else if (this.customer.tax && !this.customer.vat) {
        return 'TAX';
      }
    }
    return undefined;
  }

  getRegistrationTypeValue(): string | undefined {
    if (this.customer) {
      if (this.customer.registrationTypeValue) {
        return this.customer.registrationTypeValue;
      }
      
      const registrationType = this.getRegistrationType();
      if (registrationType === 'VAT' && this.customer.vat) {
        return this.customer.vat;
      } else if (registrationType === 'TAX' && this.customer.tax) {
        return this.customer.tax;
      }
    }
    return undefined;
  }

  private getCreatedCustomerId(response: any): number | null {
    const rawId = response?.data?.customer?.customerId
      ?? response?.data?.customerId
      ?? response?.data?.id
      ?? response?.customer?.customerId
      ?? response?.customerId
      ?? response?.id;
    const id = Number(rawId);
    return Number.isFinite(id) && id > 0 ? id : null;
  }
}
